import { render, staticRenderFns } from "./DetailOpen.vue?vue&type=template&id=e54e8e84&scoped=true&"
import script from "./DetailOpen.vue?vue&type=script&lang=js&"
export * from "./DetailOpen.vue?vue&type=script&lang=js&"
import style0 from "./DetailOpen.vue?vue&type=style&index=0&id=e54e8e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54e8e84",
  null
  
)

export default component.exports